import { render, staticRenderFns } from "./TextHeaderModule.vue?vue&type=template&id=01df0153&"
import script from "./TextHeaderModule.ts?vue&type=script&lang=ts&"
export * from "./TextHeaderModule.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports